import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import './app.css';
import MapGL from 'react-map-gl';
//import WebMercatorViewport from 'viewport-mercator-project';
//import easeCubic from 'd3-ease';
import turfbbox from '@turf/bbox';
import config from '../../config/config.json';
import Pbf from 'pbf';
import geobuf from 'geobuf';
import Select from 'react-select';
//import ProtoDeck from 'proto-deck';
//import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import {Regions} from '../common/proto_mobilite.js';
import {RegionsValidity} from '../common/proto_mobilite_validity.js';
import regionPbfData from '../../data/regions/regions.pbf';
import smPbfData from '../../data/regions/sm.pbf';
import regionPbfValidityData from '../../data/regions/regions_validity.pbf';
import smPbfValidityData from '../../data/regions/sm_validity.pbf';
import Panel from './Panel.js';
import Modal from './ui/Modal.js';
import FAQModal from './ui/FAQModal.js';
import GlossaryModal from './ui/GlossaryModal.js';
//import Arcs from './Arcs.js';
import {slide as Menu} from 'react-burger-menu';
//import DeckGL, {ArcLayer, TripsLayer, GeoJsonLayer} from 'deck.gl';
import DeckGL, {GeoJsonLayer} from 'deck.gl';
import Switch from 'react-switch';
//import ControlPanel from './ControlPanel.js';
//import FPSStats from 'react-stats-zavatta';
import sm from '../../data/sm_cut.pbf';
import regions from '../../data/regions.pbf';
import colors from '../../config/colors.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock,faCog,faTable,faPause,faRoute,faGlobeAmericas,faBars,faInfoCircle,faEye,faFont,faPlus,faMinus,faMap,faCubes,faPercent,faQuestionCircle, faWindowMaximize, faEnvelope, faBook} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import {isMobile,isIOS} from 'react-device-detect';
//import { CSSTransition } from 'react-transition-group';
import LocalStorage from 'local-storage';
import ReactGA from 'react-ga';
import {EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton} from "react-share";

ReactGA.initialize(config.trackingId);
ReactGA.pageview('index');
const emptyGeoJSON = {"type": "FeatureCollection", "features": []};
const zoomThreshold = 10;
const defaultMode = config.defaultMode;
const smGeoJSON = geobuf.decode(new Pbf(sm));
const regionsGeoJSON = geobuf.decode(new Pbf(regions));


const pbfr = new Pbf(regionPbfData);
const pbfs = new Pbf(smPbfData);
const objr = [...(Regions.read(pbfr)['regions']),...(Regions.read(pbfs)['regions'])];
const pbfrv = new Pbf(regionPbfValidityData);
const pbfsv = new Pbf(smPbfValidityData);
const objrv = [...(RegionsValidity.read(pbfrv)['regions']), ...(RegionsValidity.read(pbfsv)['regions'])];

const regionData = objr.reduce((obj,item) => Object.assign(obj, {[item.region]: item}), {});
const validityData = objrv.reduce((obj,item) => Object.assign(obj, {[item.region]: item}), {});

const regionDictionary = {
  "1": "centre_ville",
  "2": "montreal_centre",
  "3": "montreal_est",
  "4": "montreal_ouest",
  "5": "rive_sud",
  "6": "laval",
  "7": "couronne_nord",
  "8": "couronne_sud"
}

class App extends Component {
  constructor(props) {
    super(props);
    const {t} = props;
    this.state = {
      viewport: {
        latitude: config.defaultLat,
        longitude: config.defaultLon,
        zoom: isMobile ? 7.4 : config.defaultZoom,
        pitch: defaultMode == 'basic' ? config.defaultPitch : 45
      },
      mode: defaultMode,
      mapLoaded: false,
      highlightFeature: null,
      xoffset: null,
      yoffset: null,
      tooltipContent: null,
      panelOpened: false,
      panelSm: null,
      panelData: null,
      modalOpened: LocalStorage('firstVisit') == null ? true : false,
      FAQModalOpened: false,
      glossaryModalOpened: false,
      placeholder: t('select_region'),
      selectOptions: [
        {
          label: t('ras'),
          options: regionsGeoJSON.features.sort((a,b) => {return a.properties.codesm - b.properties.codesm}).map(f => {
            return({
              label: t('region_' + f.properties.codesm),
              option: f.properties.codesm,
              feature: f
            })
          })
        },
        ...([1,2,3,4,5,6,7,8].map((ra) => {
          return({
            label: t('sms') + ' (' + t('trimmed.region_' + ra) + ')',
            options: smGeoJSON.features.filter(f => f.properties.ra == ra).sort((a,b) => {
              const nameA = t('region_' + a.properties.codesm).toUpperCase();
              const nameB = t('region_' + b.properties.codesm).toUpperCase();
              if (nameA < nameB) {
                return -1;
              } else if (nameA > nameB) {
                return 1;
              } else {
                return 0
              }
            }).map(f => {
              return({
                label: t('region_' + f.properties.codesm),
                option: f.properties.codesm,
                feature: f
              })
            })
          })
        }))
      ],

      /*Object.entries(regionData).sort((a,b) => {return a[0] - b[0]}).map((r) => {
        return ({
          label: 'TEST', options: {
          label: t('region_' + [...smGeoJSON.features,...regionsGeoJSON.features].find(region => region.properties.codesm == r[0]).properties.codesm), 
          option: r[0], 
          feature: [...smGeoJSON.features,...regionsGeoJSON.features].find(region => region.properties.codesm == r[0])
        }})
      }),*/
      selectedOption: null,
      hoveredGeoJson: emptyGeoJSON,
      menuOpened: false,
      highContrast: false,
      useTables: false,
      usePercent: true,
      printMode: false,
      tripsData: null,
      time: config.startTime,
      animating: false,
      animationSpeed: 0,
      startTime: config.startTime,
      endTime: config.endTime,
      debug: config.debug,
      windowWidth: 0, 
      windowHeight: 0
    }

    this._closePanel = this._closePanel.bind(this);
    this._closeModal = this._closeModal.bind(this);
    this._pauseAnimation = this._pauseAnimation.bind(this);
    this._startAnimation = this._startAnimation.bind(this);
    this._updateTime = this._updateTime.bind(this);
    this._setArcTooltip = this._setArcTooltip.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    this._toggleUseTables = this._toggleUseTables.bind(this);
    this._useTables = this._useTables.bind(this);
    this._useGraphs = this._useGraphs.bind(this);
    this._toggleUsePercent = this._toggleUsePercent.bind(this);
    this._usePercent = this._usePercent.bind(this);
    this._useAbsolute = this._useAbsolute.bind(this);
  }

  componentDidMount() {
    this.map = this.reactMap.getMap();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    this._stopAnimation();
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
  }

  //Deck.gl related animation functions
  _pauseAnimation() {
    this.setState({
      animating: false,
      animationSpeed: 0
    });
    if (this._animationFrame) {
      window.cancelAnimationFrame(this._animationFrame);
    }
  }

  _startAnimation(speed) {
    if (this._animationFrame) {
      window.cancelAnimationFrame(this._animationFrame);
    }
    if (this.state.time > config.endTime || this.state.time < config.startTime) {
      this._pauseAnimation();
      if (this.state.time < config.startTime) {
        this.setState({ time: config.startTime });
      } else {
        this.setState({ time: config.endTime });
      }
    } else {
      this.setState({
        time: this.state.time + speed,
        animating: true,
        animationSpeed: speed
      });
      this._animationFrame = window.requestAnimationFrame(this._startAnimation.bind(this, speed));
    }
    //this._animate();
  }

  _stopAnimation() {
    if (this._animationFrame) {
      window.cancelAnimationFrame(this._animationFrame);
    }
  }

  _updateTime(time) {
    this._pauseAnimation();
    this.setState({
      time: time,
      animating: false
    });
  }

  onViewportChange = viewport => { 
    const {width, height, ...etc} = viewport
    this.setState({viewport: etc})
  }

  _pbf2geojson(buffer) {
    return geobuf.decode(new Pbf(buffer));
  }

  _onMapLoad() {
    //This and more to set the language correctly (will have to add a plugin for i18n to determine the user's language)
    this.map.setLayoutProperty('country-label-lg', 'text-field', '{name_fr}')
    this.state.mode == 'basic' ? this._addLayers() : null;
  }

  _addLayers() {

  }

  _easeTo(viewport, transitionDuration = 1000) {
    let newViewport = {...viewport, ...{
      transitionDuration: transitionDuration,
      transitionInterpolator: new FlyToInterpolator(),
      transitionEasing: easeCubic
    }}
    this.setState({viewport: newViewport});
  }

  _closePanel() {
    this.setState({
      panelOpened: false,
      hoveredGeoJson: emptyGeoJSON,
      highlightFeature: null,
      xoffset: null,
      yoffset: null,
      tooltipContent: null,
      panelSm: null,
      panelData: null,
      selectedOption: null
    })
  }

  _closeModal() {
    LocalStorage.get('firstVisit') == null && this.state.modalOpened && ReactGA.event({category: 'Navigation', action: 'Close Modal'});
    this.setState({
      modalOpened: false,
      FAQModalOpened: false,
      glossaryModalOpened: false
    }), LocalStorage.set('firstVisit', false);
  }

  _onShareButtonClick(media) {
    ReactGA.event({category: 'Sharing', action: media})
  }

  _setArcTooltip(x,y,message) {
    this.setState({
      xoffset: x, 
      yoffset: y, 
      tooltipContent: message
    })
  }

  _renderTooltip() {
    return  (
      this.state.tooltipContent && !this.state.panelOpened && (this.state.mode === 'basic' || this.state.mode === 'spider') ? <div 
        style={{
          left: this.state.xoffset, 
          top: this.state.yoffset, 
          visibility: this.state.tooltipContent ? 'visible' : 'hidden'
        }} 
        className="mapTooltip"
      >
        {this.state.tooltipContent}
      </div> : null
    )
  }

  _onHover = (object) => {
    if (this.state.mode == "basic" && object.object) {
      this.setState({
        hoveredGeoJson: object.object,
        highlightFeature: object.object.properties.id,
        xoffset: object.x,
        yoffset: object.y,
        tooltipContent: object.object.properties.nomsm
      })
    } else if (!this.state.panelOpened) {
      this.setState({
        hoveredGeoJson: emptyGeoJSON,
        highlightFeature: null,
        xoffset: null,
        yoffset: null,
        tooltipContent: null
      });
    }
  }

  _onClick = (object) => {
    //const transitionDuration = 1000;
    //const bbox = turfbbox(object.object);
    //const currentViewport = {
    //  latitude: this.state.viewport.latitude,
    //  longitude: this.state.viewport.longitude,
    //  zoom: this.state.viewport.zoom,
    //  width: 1400, //TODO: de-hardcode
    //  height: 940 //TODO: de-hardcode
    //};
//
    //const {longitude,latitude,zoom} = new WebMercatorViewport(currentViewport).fitBounds(
    //  [[bbox[0],bbox[1]],[bbox[2],bbox[3]]], {
    //    padding: {top: 50, bottom: 50, left: 50, right: 850} //TODO: de-hardcode
    //  }
    //);
//
    //const viewport = {
    //  ...this.state.viewport,
    //  longitude,
    //  latitude,
    //  zoom,
    //  transitionDuration: transitionDuration,
    //  transitionInterpolator: new FlyToInterpolator(),
    //  transitionEasing: easeCubic
    //}
    //this.setState({
    //  viewport: viewport,
    //  hoveredGeoJson: object.object,
    //  selectedOption: this.state.viewport.zoom < zoomThreshold ? this.state.selectOptions.find(o => o.option === object.object.properties.id) : null
    //}),setTimeout(() => {
    //  this.setState({
    //    hoveredGeoJson: object.object,
    //    highlightFeature: object.object.properties.id,
    //    xoffset: null,
    //    yoffset: null,
    //    tooltipContent: null,
    //    panelOpened: true,
    //    panelSm: object.object,
    //    panelData: rivesud
    //  });
    //}, transitionDuration)
    this.setState({
      hoveredGeoJson: object.object,
      highlightFeature: object.object.properties.codesm,
      xoffset: null,
      yoffset: null,
      tooltipContent: null,
      panelOpened: true,
      panelSm: object.object,
      panelData: regionData[object.object.properties.codesm.toString()],
      selectedOption: _.flatten(this.state.selectOptions.map(ra => ra.options)).find(o => o.option == object.object.properties.codesm.toString())
    });
  }

  _toggleUseTables() {
    this.setState({useTables: !this.state.useTables})
  }

  _useTables() {
    this.setState({useTables: true})
  }

  _useGraphs() {
    this.setState({useTables: false})
  }

  _toggleUsePercent() {
    this.setState({usePercent: !this.state.usePercent})
  }

  _usePercent() {
    this.setState({usePercent: true})
  }

  _useAbsolute() {
    this.setState({usePercent: false})
  }

  _switchToBasic() {
    this.setState({mode: "basic", animating: false, menuOpened: false});
    this._stopAnimation();
    this._easeTo({
      latitude: config.defaultLat,
      longitude: config.defaultLon,
      zoom: config.defaultZoom,
      pitch: config.defaultPitch
    }, 1500);
  }

  _switchToSpider() {
    this.setState({mode: "spider", panelOpened: false, animating: false, menuOpened: false});
    this._stopAnimation();
    this._easeTo({
      latitude: config.defaultLat,
      longitude: config.defaultLon,
      zoom: config.defaultZoom,
      pitch: 45
    }, 1500);
  }

  _switchToTrips() {
    if (!this.state.tripsData) {
      fetch('../../data/deck_trips_metro.pbf')
        .then(resp => resp.arrayBuffer())
        .then(data => this.setState({tripsData: ProtoDeck.decodeTrips(data)}));
    }
    this.setState({mode: "trips", panelOpened: false, menuOpened: false});
    this._easeTo({
      latitude: config.defaultLat,
      longitude: config.defaultLon,
      zoom: config.defaultZoom,
      pitch: 0
    }, 1500);
  }

  _switchToBins() {
    if (!this.state.binData) {
      fetch('../../data/bin_test.geojson')
        .then(resp => resp.json())
        .then(data => this.setState({binData: data}));
    }
    this.setState({mode: "bins", panelOpened: false, menuOpened: false});
    this._easeTo({
      latitude: config.defaultLat,
      longitude: config.defaultLon,
      zoom: config.defaultZoom,
      pitch: 45
    }, 1500);
  }

  _setSelectOptions() {
    regionsGeoJSON.features.sort((a,b) => {return a.properties.id - b.properties.id}).map((r)=> {return ({label: t((this.state.windowWidth < 400 ? 'trimmed.region_' : 'region_') + r.properties.codesm), option: r.properties.codesm, feature: r})});
  }

  _selectRegion = (regionId) => {
    this.setState({
      selectedOption: _.flatten(this.state.selectOptions.map(ra => ra.options)).find(o => regionId == o.option),
      panelData: regionData[regionId.toString()],
      panelSm: _.flatten(this.state.selectOptions.map(ra => ra.options)).find(o => regionId == o.option).feature,
      highlightFeature: _.flatten(this.state.selectOptions.map(ra => ra.options)).find(o => regionId == o.option).option,
      hoveredGeoJson: [...smGeoJSON.features,...regionsGeoJSON.features].find(f => f.properties.codesm === regionId),
      panelOpened: true,
    });
  };

  _getCursor = ({isHovering, isDragging}) => {
    return isHovering ? 'pointer' : 'default';
  };

  /* Off for now
            <div onClick={(e) => e.stopPropagation()}>
              <label>
                <span>Afficher les tableaux en version imprimable</span>
                <Switch onChange={() => {this.setState({printMode: !this.state.printMode})}} checked={this.state.printMode} disabled={!this.state.useTables} />
              </label>
            </div>
  */

  _hexTorgba = (hex, alpha) => {
    let content = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return [parseInt(content[1],16),parseInt(content[2],16),parseInt(content[3],16),alpha]
  }


  render() {
    const {t} = this.props;
    const shareUrl = "https://resultatsod.artm.quebec";
    //See following stackoverflow question for some basics https://stackoverflow.com/questions/51758932/react-select-background-color-issues
    const dot = (color = '#ccc') => ({
      alignItems: 'center',
      display: 'flex',
    
      ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
      },
    });
    const customStyles = {
      control: (base, state) => ({
        ...base,
        fontSize: 14,
        background: "#fff",
        borderRadius: "4px",
        borderColor: state.isFocused ? "#fff" : "#fff",
        "&:hover": {
          borderColor: state.isFocused ? "#fff" : "#fff"
        }
      }),
      option: (styles, {data, isEnabled, isFocused, isSelected}) => {
        return {
          ...styles,
          ...dot(colors['regions'][regionDictionary[data.feature.properties.ra.toString()]]),
          fontSize: 14,
          backgroundColor: isFocused ? "#dadada" : "#fff",
          color: "#000",
          ':active': {
            ...styles[':active'],
            backgroundColor: "#fff"
          }
        }
      },
      input: (styles) => {
        return {
          fontSize: 12,
          ...styles,
          color: "#000"
        }
      },
      noOptionsMessage: (styles) => {
        return {
          backgroundColor: "#fff",
          color: "#000"
        }
      },
      singleValue: (styles, { data }) => ({ 
        ...styles, 
        color: "#000"
      }),
      placeholder: styles => ({ 
        ...styles, 
        color: "#000"
      }),
      menu: base => ({
        ...base,
        // override border radius to match the box
        borderRadius: 0,
        // kill the gap
        marginTop: 0
      }),
      menuList: base => ({
        ...base,
        // kill the white space on first and last option
        padding: 0
      })
    }

    return (
      <div>
        {this.state.modalOpened ? <Modal onBorderClick={this._closeModal} /> : null}
        {this.state.FAQModalOpened ? <FAQModal onBorderClick={this._closeModal} /> : null}
        {this.state.glossaryModalOpened ? <GlossaryModal onBorderClick={this._closeModal} /> : null}
        <div className="navbar">
          <div className="navbarFlex">
            <div className="leftNavbar">
              <button id="burgerButton" title="Menu" onClick={() => this.setState({menuOpened: !this.state.menuOpened})}><FontAwesomeIcon id="burgerIcon" color="black" icon={faBars} size="2x" /></button>
              <div id="logoBackground">
                <svg id="logo" enableBackground="new 0 0 79.6 20.5" viewBox="0 0 79.6 20.5" xmlns="http://www.w3.org/2000/svg"><path d="m79.6 18c-.1-1.1-1.1-1.9-2.2-1.9h-1.2v-13.8c0-1.2-1-2.2-2.2-2.2h-.5c-.9 0-1.5.4-2 1.1l-5.3 8.6-5.3-8.6c-.4-.7-1.1-1.1-2-1.1h-16.7c-1.1 0-2 .8-2.1 1.9-.1 1.2.8 2.2 2 2.2h3.9v12.3h-8l-2.8-3.7c2.4-1 4-2.9 4-6.1v-.1c0-1.9-.6-3.4-1.7-4.5-1.3-1.3-3.3-2-5.8-2h-6.9c-1.2 0-2.2 1-2.2 2.2v14.2h-1l-6.5-14.8c-.5-1-1.4-1.7-2.6-1.7h-.3c-1.2 0-2.1.7-2.6 1.7l-6.3 14.4h-1.1c-1.2 0-2.2.9-2.2 2.1s1 2.2 2.2 2.2h2.3c.9 0 1.6-.5 2-1.4l1.5-3.2h8.8l1.3 3.1c.4.9 1.1 1.5 2.1 1.5h4.6.1c1.2 0 2.1-1 2.1-2.2v-14.2h4.3c2.1 0 3.4 1 3.4 2.8v.1c0 1.7-1.2 2.8-3.4 2.8h-2.7c-.5 0-.8.6-.5 1l6.5 8.6c.5.7 1.2 1.1 2.2 1.1h.1 11.4c1 0 1.9-.8 2-1.7 0-.1 0-.3 0-.5v-14.1h5.8v14.2c0 1.2.9 2.2 2.1 2.2s2.2-.9 2.2-2.1v-10.2l3.8 5.8c.5.7 1 1.1 1.8 1.1s1.4-.4 1.8-1.1l3.8-5.9v10.1c0 1.2.9 2.2 2.1 2.2h3.5c1.5.1 2.6-1.1 2.4-2.4zm-64.5-6h-5.5l2.8-6.6z" fill="#fff"></path></svg>
                <svg id="logoText" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 335.6 54.200001" xmlSpace="preserve"> <g transform="translate(-16.6,-46.9)" id="Logo" ><g id="g4070" ><path className="st1" d="m 16.8,64.5 7.3,-16 c 0.3,-0.6 0.6,-0.9 1.3,-0.9 h 0.1 c 0.6,0 1,0.3 1.3,0.9 l 7.3,16 c 0.1,0.2 0.1,0.4 0.1,0.5 0,0.5 -0.4,1 -1,1 -0.5,0 -0.8,-0.3 -1,-0.7 l -1.9,-4.2 h -9.9 l -1.9,4.2 c -0.2,0.4 -0.5,0.7 -1,0.7 -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.2 0.1,-0.4 0.2,-0.6 z M 29.6,59.2 25.4,50 21.2,59.2 Z" id="path3988" /><path className="st1" d="m 49,65 c 0,0.5 -0.4,1 -1,1 -0.5,0 -1,-0.4 -1,-1 v -1.4 c -0.9,1.4 -2.3,2.6 -4.6,2.6 -3.2,0 -5.1,-2.2 -5.1,-5.3 v -7.4 c 0,-0.6 0.4,-1 1,-1 0.5,0 1,0.4 1,1 v 6.9 c 0,2.5 1.3,4 3.7,4 2.3,0 4,-1.7 4,-4.2 v -6.8 c 0,-0.6 0.4,-1 1,-1 0.5,0 1,0.4 1,1 z" id="path3990" /><path className="st1" d="m 54.2,62.3 v -8.1 h -1.1 c -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.5 0.4,-0.9 0.9,-0.9 h 1.1 v -3.2 c 0,-0.5 0.4,-1 1,-1 0.5,0 1,0.5 1,1 v 3.2 h 3.5 c 0.5,0 0.9,0.4 0.9,0.9 0,0.5 -0.4,0.9 -0.9,0.9 H 56.2 V 62 c 0,1.6 0.9,2.2 2.2,2.2 0.7,0 1.1,-0.2 1.2,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.4 -0.2,0.6 -0.6,0.8 -0.6,0.2 -1.2,0.4 -2,0.4 -2.1,0 -3.7,-1.1 -3.7,-3.8 z" id="path3992" /><path className="st1" d="m 62.7,59.2 v 0 c 0,-3.8 2.9,-7 7,-7 4,0 6.9,3.2 6.9,6.9 v 0.1 c 0,3.8 -3,7 -7,7 -4,0 -6.9,-3.2 -6.9,-7 z m 11.8,0 v 0 c 0,-2.9 -2.1,-5.3 -5,-5.3 -2.9,0 -4.9,2.3 -4.9,5.2 v 0.1 c 0,2.9 2.1,5.2 4.9,5.2 3,0 5,-2.3 5,-5.2 z" id="path3994" /><path className="st1" d="m 80.2,53.4 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 2.5 c 1,-2.2 2.9,-3.6 4.6,-3.6 0.6,0 1,0.4 1,1 0,0.5 -0.4,0.9 -0.9,1 -2.6,0.3 -4.7,2.2 -4.7,6.1 V 65 c 0,0.5 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path3996" /><path className="st1" d="m 90.6,48.3 c 0,-0.6 0.5,-1.1 1.2,-1.1 0.7,0 1.2,0.4 1.2,1.1 v 0.3 c 0,0.6 -0.5,1.1 -1.2,1.1 -0.6,0 -1.2,-0.4 -1.2,-1.1 z m 0.2,5.1 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 V 65 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path3998" /><path className="st1" d="M 98.1,62.3 V 54.2 H 97 c -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.5 0.4,-0.9 0.9,-0.9 h 1.1 v -3.2 c 0,-0.5 0.4,-1 1,-1 0.5,0 1,0.5 1,1 v 3.2 h 3.5 c 0.5,0 0.9,0.4 0.9,0.9 0,0.5 -0.4,0.9 -0.9,0.9 h -3.5 V 62 c 0,1.6 0.9,2.2 2.2,2.2 0.7,0 1.1,-0.2 1.2,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.4 -0.2,0.6 -0.6,0.8 -0.6,0.2 -1.2,0.4 -2,0.4 -2.1,0 -3.7,-1.1 -3.7,-3.8 z" id="path4000" /><path className="st1" d="m 113.3,66.2 c -3.7,0 -6.7,-2.8 -6.7,-6.9 v -0.1 c 0,-3.8 2.7,-6.9 6.4,-6.9 4,0 6.2,3.2 6.2,6.8 0,0.5 -0.4,0.9 -0.9,0.9 h -9.7 c 0.3,2.9 2.3,4.5 4.7,4.5 1.7,0 2.9,-0.6 3.8,-1.5 0.2,-0.1 0.3,-0.2 0.6,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.2 -0.1,0.5 -0.3,0.6 -1.2,1.1 -2.7,1.9 -5,1.9 z m 3.9,-7.8 c -0.2,-2.4 -1.6,-4.5 -4.3,-4.5 -2.3,0 -4.1,1.9 -4.3,4.5 z m -4.7,-8.2 c 0,-0.1 0.1,-0.3 0.1,-0.4 l 1.5,-2.3 c 0.3,-0.4 0.5,-0.6 0.9,-0.6 0.6,0 1.4,0.4 1.4,0.8 0,0.2 -0.2,0.4 -0.4,0.6 l -1.9,1.8 c -0.4,0.4 -0.7,0.5 -1.2,0.5 -0.2,0 -0.4,-0.2 -0.4,-0.4 z" id="path4002" /><path className="st1" d="m 130.5,53.4 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 2.5 c 1,-2.2 2.9,-3.6 4.6,-3.6 0.6,0 1,0.4 1,1 0,0.5 -0.4,0.9 -0.9,1 -2.6,0.3 -4.7,2.2 -4.7,6.1 V 65 c 0,0.5 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4004" /><path className="st1" d="m 146.2,66.2 c -3.7,0 -6.7,-2.8 -6.7,-6.9 v -0.1 c 0,-3.8 2.7,-6.9 6.4,-6.9 4,0 6.2,3.2 6.2,6.8 0,0.5 -0.4,0.9 -0.9,0.9 h -9.7 c 0.3,2.9 2.3,4.5 4.7,4.5 1.7,0 2.9,-0.6 3.8,-1.5 0.2,-0.1 0.3,-0.2 0.6,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.2 -0.1,0.5 -0.3,0.6 -1.2,1.1 -2.7,1.9 -5,1.9 z m 4,-7.8 c -0.2,-2.4 -1.6,-4.5 -4.3,-4.5 -2.3,0 -4.1,1.9 -4.3,4.5 z m -4.8,-8.2 c 0,-0.1 0.1,-0.3 0.1,-0.4 l 1.5,-2.3 c 0.3,-0.4 0.5,-0.6 0.9,-0.6 0.6,0 1.4,0.4 1.4,0.8 0,0.2 -0.2,0.4 -0.4,0.6 l -1.9,1.8 c -0.4,0.4 -0.7,0.5 -1.2,0.5 -0.2,0 -0.4,-0.2 -0.4,-0.4 z" id="path4006" /><path className="st1" d="m 156,68.5 c -0.3,-0.2 -0.5,-0.5 -0.5,-0.8 0,-0.4 0.4,-0.9 0.9,-0.9 0.2,0 0.3,0.1 0.4,0.1 1.4,0.9 3,1.4 4.7,1.4 2.9,0 4.9,-1.6 4.9,-4.8 V 62 c -1.2,1.5 -2.8,2.8 -5.2,2.8 -3.2,0 -6.3,-2.4 -6.3,-6.2 v -0.1 c 0,-3.9 3.1,-6.3 6.3,-6.3 2.5,0 4.1,1.2 5.2,2.7 v -1.5 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.5 1,1 v 10.1 c 0,2.1 -0.6,3.6 -1.7,4.7 -1.2,1.2 -3,1.8 -5.1,1.8 -2.1,0 -3.9,-0.5 -5.6,-1.5 z m 10.4,-10 v 0 c 0,-2.8 -2.4,-4.6 -4.9,-4.6 -2.5,0 -4.6,1.8 -4.6,4.5 v 0.1 c 0,2.7 2.1,4.5 4.6,4.5 2.6,0.1 4.9,-1.8 4.9,-4.5 z" id="path4008" /><path className="st1" d="m 172.8,48.3 c 0,-0.6 0.5,-1.1 1.2,-1.1 0.7,0 1.2,0.4 1.2,1.1 v 0.3 c 0,0.6 -0.5,1.1 -1.2,1.1 -0.6,0 -1.2,-0.4 -1.2,-1.1 z m 0.2,5.1 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 V 65 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4010" /><path className="st1" d="m 178.8,59.2 v 0 c 0,-3.8 2.9,-7 7,-7 4,0 6.9,3.2 6.9,6.9 v 0.1 c 0,3.8 -3,7 -7,7 -4,0 -6.9,-3.2 -6.9,-7 z m 11.8,0 v 0 c 0,-2.9 -2.1,-5.3 -5,-5.3 -2.9,0 -4.9,2.3 -4.9,5.2 v 0.1 c 0,2.9 2.1,5.2 4.9,5.2 3,0 5,-2.3 5,-5.2 z" id="path4012" /><path className="st1" d="m 196.3,53.4 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 1.4 c 0.9,-1.4 2.3,-2.6 4.6,-2.6 3.2,0 5.1,2.2 5.1,5.3 V 65 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 v -6.9 c 0,-2.5 -1.3,-4 -3.7,-4 -2.3,0 -4,1.7 -4,4.2 V 65 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4014" /><path className="st1" d="m 211.2,62 v 0 c 0,-2.9 2.3,-4.4 5.7,-4.4 1.7,0 2.9,0.2 4.1,0.6 v -0.5 c 0,-2.4 -1.5,-3.6 -4,-3.6 -1.3,0 -2.5,0.3 -3.5,0.7 -0.1,0.1 -0.3,0.1 -0.4,0.1 -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.4 0.3,-0.7 0.5,-0.8 1.3,-0.6 2.7,-0.9 4.4,-0.9 1.9,0 3.3,0.5 4.3,1.5 0.9,0.9 1.4,2.2 1.4,3.9 V 65 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-0.9 v -1.2 c -0.9,1.2 -2.5,2.3 -4.8,2.3 -2.3,-0.1 -4.8,-1.5 -4.8,-4.2 z m 9.8,-1.1 v -1.3 c -1,-0.3 -2.3,-0.6 -3.9,-0.6 -2.5,0 -3.9,1.1 -3.9,2.8 v 0.1 c 0,1.7 1.5,2.7 3.4,2.7 2.4,0 4.4,-1.5 4.4,-3.7 z" id="path4016" /><path className="st1" d="m 227.3,47.9 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.5 1,1 V 65 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4018" /><path className="st1" d="m 239.7,66.2 c -3.7,0 -6.7,-2.8 -6.7,-6.9 v -0.1 c 0,-3.8 2.7,-6.9 6.4,-6.9 4,0 6.2,3.2 6.2,6.8 0,0.5 -0.4,0.9 -0.9,0.9 H 235 c 0.3,2.9 2.3,4.5 4.7,4.5 1.7,0 2.9,-0.6 3.8,-1.5 0.2,-0.1 0.3,-0.2 0.6,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.2 -0.1,0.5 -0.3,0.6 -1.2,1.1 -2.7,1.9 -5,1.9 z m 4,-7.8 c -0.2,-2.4 -1.6,-4.5 -4.3,-4.5 -2.3,0 -4.1,1.9 -4.3,4.5 z" id="path4020" /><path className="st1" d="m 30.3,95.9 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 v -1.8 c -1.1,1.6 -2.7,3 -5.1,3 -3.2,0 -6.4,-2.5 -6.4,-6.9 v -0.1 c 0,-4.4 3.2,-6.9 6.4,-6.9 2.5,0 4.1,1.3 5.1,2.8 v -7.2 c 0,-0.6 0.4,-1 1,-1 0.6,0 1,0.4 1,1 z M 18.8,90.1 v 0 c 0,3.2 2.2,5.2 4.7,5.2 2.5,0 4.8,-2.1 4.8,-5.2 V 90 c 0,-3.1 -2.3,-5.1 -4.8,-5.1 -2.6,0.1 -4.7,2 -4.7,5.2 z" id="path4022" /><path className="st1" d="m 40.5,97.1 c -3.7,0 -6.7,-2.8 -6.7,-6.9 v -0.1 c 0,-3.8 2.7,-6.9 6.4,-6.9 4,0 6.2,3.2 6.2,6.8 0,0.5 -0.4,0.9 -0.9,0.9 h -9.7 c 0.3,2.9 2.3,4.5 4.7,4.5 1.7,0 2.9,-0.6 3.8,-1.5 0.2,-0.1 0.3,-0.2 0.6,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.2 -0.1,0.5 -0.3,0.6 -1.2,1.1 -2.7,1.9 -5,1.9 z m 4,-7.7 c -0.2,-2.4 -1.6,-4.5 -4.3,-4.5 -2.3,0 -4.1,1.9 -4.3,4.5 z" id="path4024" /><path className="st1" d="m 58.4,93.3 v -8.1 h -1.1 c -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.5 0.4,-0.9 0.9,-0.9 h 1.1 v -3.2 c 0,-0.5 0.4,-1 1,-1 0.5,0 1,0.5 1,1 v 3.2 h 3.5 c 0.5,0 0.9,0.4 0.9,0.9 0,0.5 -0.4,0.9 -0.9,0.9 H 60.4 V 93 c 0,1.6 0.9,2.2 2.2,2.2 0.7,0 1.1,-0.2 1.2,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.4 -0.2,0.6 -0.6,0.8 -0.6,0.2 -1.2,0.4 -2,0.4 -2.1,0 -3.7,-1.1 -3.7,-3.8 z" id="path4026" /><path className="st1" d="m 68.1,84.4 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 2.5 c 1,-2.2 2.9,-3.6 4.6,-3.6 0.6,0 1,0.4 1,1 0,0.5 -0.4,0.9 -0.9,1 -2.6,0.3 -4.7,2.2 -4.7,6.1 v 4.5 c 0,0.5 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4028" /><path className="st1" d="m 76.9,93 v 0 c 0,-2.9 2.3,-4.4 5.7,-4.4 1.7,0 2.9,0.2 4.1,0.6 v -0.5 c 0,-2.4 -1.5,-3.6 -4,-3.6 -1.3,0 -2.5,0.3 -3.5,0.7 -0.1,0.1 -0.3,0.1 -0.4,0.1 -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.4 0.3,-0.7 0.5,-0.8 1.3,-0.6 2.7,-0.9 4.4,-0.9 1.9,0 3.3,0.5 4.3,1.5 0.9,0.9 1.4,2.2 1.4,3.9 V 96 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-0.9 V 94.9 C 85.6,96.1 84,97.2 81.7,97.2 79.4,97.1 76.9,95.7 76.9,93 Z m 9.9,-1.1 V 90.6 C 85.8,90.3 84.5,90 82.9,90 80.4,90 79,91.1 79,92.8 v 0.1 c 0,1.7 1.5,2.7 3.4,2.7 2.4,-0.1 4.4,-1.6 4.4,-3.7 z" id="path4030" /><path className="st1" d="m 92.9,84.4 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 1.4 c 0.9,-1.4 2.3,-2.6 4.6,-2.6 3.2,0 5.1,2.2 5.1,5.3 v 7.4 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 V 89 c 0,-2.5 -1.3,-4 -3.7,-4 -2.3,0 -4,1.7 -4,4.2 V 96 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4032" /><path className="st1" d="m 108.1,95.4 c -0.2,-0.1 -0.4,-0.4 -0.4,-0.7 0,-0.5 0.4,-0.9 0.9,-0.9 0.2,0 0.4,0.1 0.5,0.2 1.4,0.9 2.8,1.4 4.2,1.4 1.6,0 2.8,-0.8 2.8,-2.1 v -0.1 c 0,-1.3 -1.6,-1.9 -3.3,-2.3 -2.1,-0.6 -4.4,-1.3 -4.4,-3.8 V 87 c 0,-2.3 1.9,-3.8 4.5,-3.8 1.4,0 3,0.4 4.3,1.1 0.3,0.2 0.5,0.4 0.5,0.8 0,0.5 -0.4,0.9 -0.9,0.9 -0.2,0 -0.3,-0.1 -0.4,-0.1 -1.1,-0.6 -2.3,-1 -3.5,-1 -1.6,0 -2.6,0.8 -2.6,1.9 v 0.1 c 0,1.3 1.7,1.8 3.4,2.3 2.1,0.6 4.3,1.4 4.3,3.8 v 0.1 c 0,2.5 -2.1,4 -4.8,4 -1.7,0 -3.7,-0.7 -5.1,-1.7 z" id="path4034" /><path className="st1" d="m 121.7,84.4 c 0,-0.6 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 1.8 c 1.1,-1.6 2.7,-3 5.1,-3 3.2,0 6.4,2.5 6.4,6.9 v 0.1 c 0,4.4 -3.1,6.9 -6.4,6.9 -2.5,0 -4.1,-1.3 -5.1,-2.8 v 5.8 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z m 11.4,5.8 v 0 c 0,-3.2 -2.2,-5.2 -4.7,-5.2 -2.5,0 -4.8,2.1 -4.8,5.1 v 0.1 c 0,3.1 2.3,5.2 4.8,5.2 2.6,-0.1 4.7,-2 4.7,-5.2 z" id="path4036" /><path className="st1" d="m 138,90.2 v 0 c 0,-3.8 2.9,-7 7,-7 4,0 6.9,3.2 6.9,6.9 v 0.1 c 0,3.8 -3,7 -7,7 -4,-0.1 -6.9,-3.2 -6.9,-7 z m 11.8,0 v 0 c 0,-2.9 -2.1,-5.3 -5,-5.3 -2.9,0 -4.9,2.3 -4.9,5.2 v 0.1 c 0,2.9 2.1,5.2 4.9,5.2 3,0 5,-2.4 5,-5.2 z" id="path4038" /><path className="st1" d="m 155.5,84.4 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 2.5 c 1,-2.2 2.9,-3.6 4.6,-3.6 0.6,0 1,0.4 1,1 0,0.5 -0.4,0.9 -0.9,1 -2.6,0.3 -4.7,2.2 -4.7,6.1 v 4.5 c 0,0.5 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4040" /><path className="st1" d="m 166.6,93.3 v -8.1 h -1.1 c -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.5 0.4,-0.9 0.9,-0.9 h 1.1 v -3.2 c 0,-0.5 0.4,-1 1,-1 0.5,0 1,0.5 1,1 v 3.2 h 3.5 c 0.5,0 0.9,0.4 0.9,0.9 0,0.5 -0.4,0.9 -0.9,0.9 h -3.5 V 93 c 0,1.6 0.9,2.2 2.2,2.2 0.7,0 1.1,-0.2 1.2,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.4 -0.2,0.6 -0.6,0.8 -0.6,0.2 -1.2,0.4 -2,0.4 -2.1,0 -3.7,-1.1 -3.7,-3.8 z" id="path4042" /><path className="st1" d="m 184.1,84.4 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 1.4 c 0.9,-1.3 2.1,-2.5 4.3,-2.5 2.2,0 3.6,1.2 4.3,2.7 1,-1.5 2.4,-2.7 4.7,-2.7 3.1,0 5,2.1 5,5.4 v 7.4 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 V 89 c 0,-2.6 -1.3,-4 -3.5,-4 -2,0 -3.7,1.5 -3.7,4.1 v 6.8 c 0,0.6 -0.4,1 -1,1 -0.5,0 -1,-0.4 -1,-1 v -7 c 0,-2.5 -1.3,-4 -3.4,-4 -2.1,0 -3.7,1.8 -3.7,4.2 v 6.7 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4044" /><path className="st1" d="m 214.5,97.1 c -3.7,0 -6.7,-2.8 -6.7,-6.9 v -0.1 c 0,-3.8 2.7,-6.9 6.4,-6.9 4,0 6.2,3.2 6.2,6.8 0,0.5 -0.4,0.9 -0.9,0.9 h -9.7 c 0.3,2.9 2.3,4.5 4.7,4.5 1.7,0 2.9,-0.6 3.8,-1.5 0.2,-0.1 0.3,-0.2 0.6,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.2 -0.1,0.5 -0.3,0.6 -1.2,1.1 -2.7,1.9 -5,1.9 z m 3.9,-7.7 c -0.2,-2.4 -1.6,-4.5 -4.3,-4.5 -2.3,0 -4.1,1.9 -4.3,4.5 z m -4.7,-8.2 c 0,-0.1 0.1,-0.3 0.1,-0.4 l 1.5,-2.3 c 0.3,-0.4 0.5,-0.6 0.9,-0.6 0.6,0 1.4,0.4 1.4,0.8 0,0.2 -0.2,0.4 -0.4,0.6 l -1.9,1.8 c -0.4,0.4 -0.7,0.5 -1.2,0.5 -0.2,0 -0.4,-0.2 -0.4,-0.4 z" id="path4046" /><path className="st1" d="m 224.6,93.3 v -8.1 h -1.1 c -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.5 0.4,-0.9 0.9,-0.9 h 1.1 v -3.2 c 0,-0.5 0.4,-1 1,-1 0.5,0 1,0.5 1,1 v 3.2 h 3.5 c 0.5,0 0.9,0.4 0.9,0.9 0,0.5 -0.4,0.9 -0.9,0.9 h -3.5 V 93 c 0,1.6 0.9,2.2 2.2,2.2 0.7,0 1.1,-0.2 1.2,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.4 -0.2,0.6 -0.6,0.8 -0.6,0.2 -1.2,0.4 -2,0.4 -2,0 -3.7,-1.1 -3.7,-3.8 z" id="path4048" /><path className="st1" d="m 234.4,84.4 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 2.5 c 1,-2.2 2.9,-3.6 4.6,-3.6 0.6,0 1,0.4 1,1 0,0.5 -0.4,0.9 -0.9,1 -2.6,0.3 -4.7,2.2 -4.7,6.1 v 4.5 c 0,0.5 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4050" /><path className="st1" d="m 243.4,90.2 v 0 c 0,-3.8 2.9,-7 7,-7 4,0 6.9,3.2 6.9,6.9 v 0.1 c 0,3.8 -3,7 -7,7 -4,-0.1 -6.9,-3.2 -6.9,-7 z m 11.9,0 v 0 c 0,-2.9 -2.1,-5.3 -5,-5.3 -2.9,0 -4.9,2.3 -4.9,5.2 v 0.1 c 0,2.9 2.1,5.2 4.9,5.2 3,0 5,-2.4 5,-5.2 z" id="path4052" /><path className="st1" d="m 260.9,84.4 c 0,-0.6 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 1.8 c 1.1,-1.6 2.7,-3 5.1,-3 3.2,0 6.4,2.5 6.4,6.9 v 0.1 c 0,4.4 -3.1,6.9 -6.4,6.9 -2.5,0 -4.1,-1.3 -5.1,-2.8 v 5.8 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z m 11.5,5.8 v 0 c 0,-3.2 -2.2,-5.2 -4.7,-5.2 -2.5,0 -4.8,2.1 -4.8,5.1 v 0.1 c 0,3.1 2.3,5.2 4.8,5.2 2.5,-0.1 4.7,-2 4.7,-5.2 z" id="path4054" /><path className="st1" d="m 277.2,90.2 v 0 c 0,-3.8 2.9,-7 7,-7 4,0 6.9,3.2 6.9,6.9 v 0.1 c 0,3.8 -3,7 -7,7 -3.9,-0.1 -6.9,-3.2 -6.9,-7 z m 11.9,0 v 0 c 0,-2.9 -2.1,-5.3 -5,-5.3 -2.9,0 -4.9,2.3 -4.9,5.2 v 0.1 c 0,2.9 2.1,5.2 4.9,5.2 3,0 5,-2.4 5,-5.2 z" id="path4056" /><path className="st1" d="m 294.9,78.9 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.5 1,1 V 96 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4058" /><path className="st1" d="m 301.5,79.3 c 0,-0.6 0.5,-1.1 1.2,-1.1 0.7,0 1.2,0.4 1.2,1.1 v 0.3 c 0,0.6 -0.5,1.1 -1.2,1.1 -0.6,0 -1.2,-0.4 -1.2,-1.1 z m 0.2,5.1 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 V 96 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4060" /><path className="st1" d="m 309,93.3 v -8.1 h -1.1 c -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.5 0.4,-0.9 0.9,-0.9 h 1.1 v -3.2 c 0,-0.5 0.4,-1 1,-1 0.5,0 1,0.5 1,1 v 3.2 h 3.5 c 0.5,0 0.9,0.4 0.9,0.9 0,0.5 -0.4,0.9 -0.9,0.9 H 311 V 93 c 0,1.6 0.9,2.2 2.2,2.2 0.7,0 1.1,-0.2 1.2,-0.2 0.5,0 0.9,0.4 0.9,0.9 0,0.4 -0.2,0.6 -0.6,0.8 -0.6,0.2 -1.2,0.4 -2,0.4 -2.1,0 -3.7,-1.1 -3.7,-3.8 z" id="path4062" /><path className="st1" d="m 317.7,93 v 0 c 0,-2.9 2.3,-4.4 5.7,-4.4 1.7,0 2.9,0.2 4.1,0.6 v -0.5 c 0,-2.4 -1.5,-3.6 -4,-3.6 -1.3,0 -2.5,0.3 -3.5,0.7 -0.1,0.1 -0.3,0.1 -0.4,0.1 -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.4 0.3,-0.7 0.5,-0.8 1.3,-0.6 2.7,-0.9 4.4,-0.9 1.9,0 3.3,0.5 4.3,1.5 0.9,0.9 1.4,2.2 1.4,3.9 V 96 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-0.9 v -1.2 c -0.9,1.2 -2.5,2.3 -4.8,2.3 -2.3,-0.1 -4.8,-1.5 -4.8,-4.2 z m 9.9,-1.1 v -1.3 c -1,-0.3 -2.3,-0.6 -3.9,-0.6 -2.5,0 -3.9,1.1 -3.9,2.8 v 0.1 c 0,1.7 1.5,2.7 3.4,2.7 2.4,-0.1 4.4,-1.6 4.4,-3.7 z" id="path4064" /><path className="st1" d="m 333.7,79.3 c 0,-0.6 0.5,-1.1 1.2,-1.1 0.7,0 1.2,0.4 1.2,1.1 v 0.3 c 0,0.6 -0.5,1.1 -1.2,1.1 -0.6,0 -1.2,-0.4 -1.2,-1.1 z m 0.2,5.1 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 V 96 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4066" /><path className="st1" d="m 340.5,84.4 c 0,-0.5 0.4,-1 1,-1 0.6,0 1,0.4 1,1 v 1.4 c 0.9,-1.4 2.3,-2.6 4.6,-2.6 3.2,0 5.1,2.2 5.1,5.3 v 7.4 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 V 89 c 0,-2.5 -1.3,-4 -3.7,-4 -2.3,0 -4,1.7 -4,4.2 V 96 c 0,0.6 -0.4,1 -1,1 -0.6,0 -1,-0.4 -1,-1 z" id="path4068" /></g></g></svg>
              </div>
            </div>
            <div></div>
          </div>
        </div>
        {isMobile ? 
          <select type="select" key="mobileSelect" className="selectSm mobileSelect" onChange={(e) => {this._selectRegion(e.target.value)}}>
            <option value="" key="mobileSelectPlaceholder" selected={this.state.selectedOption == null} disabled>{t('select_region')}</option>
            {this.state.selectOptions.map((ra) => {
              return(
                <optgroup label={ra.label}>
                  {ra.options.map(region => <option key={`mobileSelectOption__${region.option}`} selected={this.state.selectedOption && this.state.selectedOption.option.toString() == region.option} value={region.option}>{t((this.state.windowWidth < 400 ? 'trimmed.region_' : 'region_') + region.option)}</option>)}
                </optgroup>
              )
            })}
          </select>

          : <Select 
            styles={customStyles}
            placeholder={this.state.placeholder}
            onMenuOpen={() => this.setState({placeholder: ''})}
            onMenuClose={() => this.setState({placeholder: t('select_region')})}
            noOptionsMessage={() => {return (t('no_option'))}}
            className={"selectSm"}
            classNamePrefix={"selectSm"}
            isSearchable={true}
            value={this.state.selectedOption}
            options={this.state.selectOptions}
            onChange={(selectedOption) => {
              this.setState({
                selectedOption: selectedOption,
                panelData: regionData[selectedOption.option.toString()],
                panelSm: selectedOption.feature,
                highlightFeature: selectedOption.option,
                hoveredGeoJson: [...smGeoJSON.features,...regionsGeoJSON.features].find(f => f.properties.codesm === parseInt(selectedOption.option)),
                panelOpened: true,
              });
            }}
          />
        }
        <div id="outer-container" className={`mainDiv ${this.state.panelOpened ? 'blur' : null}`}>
          <Menu 
            className={'menu'} 
            pageWrapId={"page-wrap"} 
            outerContainerId={"outer-container"} 
            isOpen={this.state.menuOpened}
            onStateChange={(state) => this.setState({menuOpened: state.isOpen})}
            width={Math.min(500,this.state.windowWidth)}
            customBurgerIcon={ false }
          >
            <div className="menuContainer">
              <div className="switchesContainer">
                <h2 className="menuTitle" onClick={(e) => e.stopPropagation()}>{t('about')}</h2>
                  <a href="https://www.artm.quebec/a-propos-de-l-artm/" className={`optionContainer bm-item`} target="_blank">
                    <div className="mapOption"><FontAwesomeIcon icon={faQuestionCircle} />&nbsp;{t('about_artm')}</div>
                  </a>
                  <a href="https://www.artm.quebec/enqueteod/" className={`optionContainer bm-item`} target="_blank">
                    <div className="mapOption"><FontAwesomeIcon icon={faQuestionCircle} />&nbsp;{t('about_od')}</div>
                  </a>
                  <div onClick={() => this.setState({modalOpened: false, FAQModalOpened: true, glossaryModalOpened: false, menuOpened: false})} className={`optionContainer bm-item`}>
                    <div className="mapOption"><FontAwesomeIcon icon={faQuestionCircle} />&nbsp;{t('faq')}</div>
                  </div>
                  <div onClick={() => this.setState({modalOpened: false, FAQModalOpened: false, glossaryModalOpened: true, menuOpened: false})} className={`optionContainer bm-item`}>
                    <div className="mapOption"><FontAwesomeIcon icon={faBook} />&nbsp;{t('glossary')}</div>
                  </div>
                  <div onClick={() => this.setState({modalOpened: true, FAQModalOpened: false, glossaryModalOpened: false, menuOpened: false})} className={`optionContainer bm-item`}>
                    <div className="mapOption"><FontAwesomeIcon icon={faWindowMaximize} />&nbsp;{t('usage_instructions')}</div>
                  </div>
                  <a href="https://www.artm.quebec/enonce-confidentialite/" className={`optionContainer bm-item`} target="_blank">
                    <div className="mapOption"><FontAwesomeIcon icon={faLock} />&nbsp;{t('confidentiality')}</div>
                  </a>
              </div>
              <div className={`menuFooter ${!this.state.menuOpened && 'hidden'}`}>
                <div className='shareButtons'>
                  <span className="shareButtonContainer" title={t('share.email')}>
                    <EmailShareButton
                      url={shareUrl}
                      subject={t('site_title')}
                      body={t('site_description')}
                      separator=" : "
                      aria-label={t('share.email')}
                    >
                      <FontAwesomeIcon icon={faEnvelope} size="2x"/>
                    </EmailShareButton>
                  </span>
                  <span className="shareButtonContainer" title={t('share.facebook')}>
                    <FacebookShareButton
                      url={shareUrl}
                      quote={t('site_description')}
                      onShareWindowClose={() => this._onShareButtonClick('facebook')}
                      aria-label={t('share.facebook')}
                    >
                      <FontAwesomeIcon icon={faFacebookF} size="2x"/>
                    </FacebookShareButton>
                  </span>
                  <span className="shareButtonContainer" title={t('share.linkedin')}>
                    <LinkedinShareButton
                      url={shareUrl}
                      onShareWindowClose={() => this._onShareButtonClick('linkedin')}
                      aria-label={t('share.linkedin')}
                    >
                      <FontAwesomeIcon icon={faLinkedinIn} size="2x"/>
                    </LinkedinShareButton>
                  </span>
                  <span className="shareButtonContainer" title={t('share.twitter')}>
                    <TwitterShareButton
                      url={shareUrl}
                      title={t('site_title')}
                      onShareWindowClose={() => this._onShareButtonClick('twitter')}
                      aria-label={t('share.twitter')}
                    >
                      <FontAwesomeIcon icon={faTwitter} size="2x" title={t('share.twitter')} />
                    </TwitterShareButton>
                  </span>
                </div>
                <div className={`menuFinePrint ${!this.state.menuOpened && 'hidden'}`}>
                  {t('file_version', {version: config.version})}
                </div>
              </div>
            </div>
          </Menu>
          <div id="page-wrap" className="page-wrap">
            <MapGL
              width='100%'
              height='100%'
              {...this.state.viewport}
              onViewportChange={viewport => this.onViewportChange(viewport)}
              mapboxApiAccessToken={config.mapboxToken}
              mapStyle='mapbox://styles/artmquebec/ck548410h21vd1ck5752vdvxf'
              getCursor={this._getCursor}
              ref={(reactMap) => this.reactMap = reactMap}
              mapOptions={
                {
                  antialias: true
                }
              }

            >
              {this.state.mode === 'basic' ? 
                <DeckGL
                  viewState={this.state.viewport}
                  layers={[
                    new GeoJsonLayer({
                      id: 'geojson',
                      data: this.state.viewport.zoom < 10 ? regionsGeoJSON : smGeoJSON,
                      //stroked: true,
                      getLineWidth: x => this.state.viewport.zoom < 10 ? 0 : 30,
                      getLineColor: [0,0,0,255],
                      filled: true,
                      getFillColor: region => this._hexTorgba(colors['regions'][regionDictionary[region.properties.ra]], 160),
                      onHover: (object) => {
                        if (this.state.mode == "basic" && object.object) {
                          this.setState({
                            hoveredGeoJson: object.object,
                            highlightFeature: object.object.properties.codesm,
                            xoffset: object.x,
                            yoffset: object.y,
                            tooltipContent: t('region_' + object.object.properties.codesm)
                          })
                        } else if (!this.state.panelOpened) {
                          this.setState({
                            hoveredGeoJson: emptyGeoJSON,
                            highlightFeature: null,
                            xoffset: null,
                            yoffset: null,
                            tooltipContent: null
                          });
                        }
                      },
                      onClick: this._onClick,
                      pickable: true
                    })
                    ,
                    new GeoJsonLayer({
                      id: 'hoveredgeojson',
                      data: this.state.hoveredGeoJson,
                      filled: true,
                      getFillColor: region => this._hexTorgba(colors['regions'][regionDictionary[region.properties.ra]], 255),
                      getLineWidth: x => this.state.viewport.zoom < 10 ? (1.0/this.state.viewport.zoom)*1800 : 0,
                      getLineColor: [0,0,0,255],
                    })
                  ]}
                /> : null
              }
            </MapGL>
            {this._renderTooltip()}
            {this.state.panelOpened && <Panel 
                isMobile={isMobile}
                data={this.state.panelData}
                validityData={validityData[this.state.panelSm.properties.codesm.toString()]}
                sm={this.state.panelSm} 
                onBorderClick={this._closePanel} 
                useTables={this.state.useTables}
                usePercent={this.state.usePercent}
                windowWidth={this.state.windowWidth}
                toggleUseTables={this._toggleUseTables}
                switchUseTables={this._useTables}
                switchUseGraphs={this._useGraphs}
                toggleUsePercent={this._toggleUsePercent}
                switchUsePercent={this._usePercent}
                switchUseAbsolute={this._useAbsolute}
              />
            }
            
  
            {this.state.debug ? <FPSStats isActive right='0' bottom='0' /> : null}
            
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(App);
